import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=ce281800&scoped=true&"
import script from "./reset-password.ts?vue&type=script&lang=ts&"
export * from "./reset-password.ts?vue&type=script&lang=ts&"
import style0 from "./reset-password.scss?vue&type=style&index=0&id=ce281800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce281800",
  null
  
)

export default component.exports